var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xml-text-com"},[_c('codemirror',{ref:"cmEditor",staticClass:"xml-text",attrs:{"options":_vm.cmOptions},model:{value:(_vm.xmlTextVal),callback:function ($$v) {_vm.xmlTextVal=$$v},expression:"xmlTextVal"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }